import { IEntityPageRequest } from "../core/contracts/IEntityPageRequest";

export interface FilterItem {
    columnName: string;
    operator: FilterItemOperator;
    value: any;
}

export type FilterItemOperator =
    | "contains"
    | "notContains"
    | ">"
    | "<"
    | ">="
    | "<="
    | "="
    | "like"
    | "between"
    | "notBetween"
    | "isNotAnyOf"
    | "isNotEmpty"
    | "isEmpty"
    | "isNull"
    | "equals"
    | "isNot"
    | "not"
    | "isAnyOf"
    | "is"
    | "after"
    | "onOrAfter"
    | "before"
    | "onOrBefore"
    | "startsWith"
    | "endsWith"
    | "notEndsWith"
    | "notStartsWith"
    | "isNotNull";

export type FilterItemValueType = {
    contains: string;
    notContains: string;
    ">": string;
    "<": string;
    ">=": string;
    "<=": string;
    "=": string;
    like: string;
    between: [string, string];
    notBetween: [string, string];
    isNotAnyOf: string[] | number[];
    isNotEmpty: true;
    isEmpty: true;
    equals: string | number;
    isNot: string | number;
    not: string | number;
    isNull: true;
    isAnyOf: string[] | number[];
    is: string | number;
    after: string;
    onOrAfter: string;
    before: string;
    onOrBefore: string;
    startsWith: string;
    endsWith: string;
    notEndsWith: string;
    notStartsWith: string;
    isNotNull: string;
};

export interface FilterPart {
    filterItems: FilterItem[];
    or?: boolean;
    not?: boolean;
}

export enum FilterOperator {
    AND = "AND",
    OR = "OR",
}

export type FieldOptions = {
    [K in FilterItemOperator]?: FilterItemValueType[K];
};

export type WhereField<T = any> = {
    [key in keyof Partial<T>]: FieldOptions;
};

export type Where<T = any> = WhereFilterOperator<T> | WhereField<T>;

export type WhereFilterOperator<T = any> = {
    [K in FilterOperator]?: (Where<T> | WhereField<T>)[];
};

export type Order = {
    [columnName: string]: string | undefined;
};

export interface Filter<T = any> {
    parts: FilterPart[];
    where?: Where<T>;
}
export const getEmptyRequest = () => {
    return {
        filter: getEmptyFilter(),
        offset: 0,
        order: {},
        select: "",
        pageSize: 10,
    } as IEntityPageRequest;
};
export const getEmptyFilter = () => {
    return { parts: [] } as Filter;
};
